const CheckpointHeader = ({ name, description }) => (
  <>
    <h4 className="font-semibold text-gray-700 max-md:text-sm">{name}</h4>
    <p className="text-sm text-gray-500 max-md:text-xs">{description}</p>
  </>
);

export default CheckpointHeader;
